import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  IAccountTransferTemplate,
  ICreateAccountTransferTemplateRequest,
  IUpdateAccountTransferTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const accountTransferTemplateApi = createApi({
  reducerPath: "accountTransferTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getAccountTransferTemplate: builder.query<IAccountTransferTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.AccountTransferTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createAccountTransferTemplate: builder.mutation<string, ICreateAccountTransferTemplateRequest>(
      withIdempotency<ICreateAccountTransferTemplateRequest>(
        TemplateApiUrls.AccountTransferTemplateV2
      )),
    updateAccountTransferTemplate: builder.mutation<string, IUpdateAccountTransferTemplateRequest>({
      query: ({ data, id }) => ({
        url: `${TemplateApiUrls.AccountTransferTemplateV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
  }),
});

export const {
  useGetAccountTransferTemplateQuery,
  useCreateAccountTransferTemplateMutation,
  useUpdateAccountTransferTemplateMutation,
} = accountTransferTemplateApi;
